// extracted by mini-css-extract-plugin
export default {"concept":"Note_concept__yto2N"};